module.exports = __webpack_public_path__ + "img/maxdividaativa.9e94bbfd.png";